import {
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { AritoActionBar, AritoActionButton, AritoIcon, AritoMenuButton } from '@/components/custom/erp';
import type { BaoCaoSoDuQuyVaNganHangSearchParams } from '@/types/schemas';
interface ActionBarProps {
  onSearchClick: () => void;
  onRefreshClick: () => void;
  onFixedColumnsClick: () => void;
  onExportDataClick: () => void;
  onEditPrintTemplateClick: () => void;
  className?: string;
  searchParams?: BaoCaoSoDuQuyVaNganHangSearchParams;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearchClick,
  onRefreshClick,
  onFixedColumnsClick,
  onEditPrintTemplateClick,
  className,
  searchParams
}) => {
  return (
    <AritoActionBar
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Báo cáo số dư tại quỹ và ngân hàng</h1>
          <div className='text-[10px] text-gray-500'>
            <p>
              <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
              <span className='font-semibold'>Đến ngày {searchParams?.ngay_ct2}</span>
            </p>
          </div>
        </div>
      }
    >
      <AritoActionButton title='Tìm kiếm' icon={Search1Stroke} onClick={onSearchClick} variant='primary' />
      <AritoActionButton title='Refresh' icon={RefreshCircle1ClockwiseStroke} onClick={onRefreshClick} />
      <AritoActionButton title='Cố định cột' icon={SignPostLeftStroke} onClick={onFixedColumnsClick} />
      <AritoMenuButton
        title='In ấn'
        icon={<Lineicons aria-hidden='true' icon={PrinterStroke} />}
        items={[
          {
            title: 'Mẫu chuẩn',
            icon: <AritoIcon icon={20} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
      <AritoMenuButton
        items={[
          {
            title: 'Chỉnh sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={18} />,
            onClick: () => {},
            group: 1
          }
        ]}
      />
    </AritoActionBar>
  );
};

export default ActionBar;
